const $ = require('cash-dom');
const Page = require('../components/page');
const Ajax = require('../components/ajax');

const MainSearch = {
  _$mainSearch: $('#main-search'),
  _$mainSearchHolder: $('#main-search-holder'),
  _$mainSearchHolderInput: $('#main-search-holder input'),
  _$mainSearchHolderResults: $('#main-search-holder .results'),

  init() {
    const self = this;

    self._$mainSearch.on('click', function (e) {
      e.preventDefault();

      self._$mainSearchHolder.toggleClass('active');
      $('body').toggleClass('search-active');
      self._$mainSearchHolderInput.first().trigger('focus');
      self._mainSearch();
    });

    $('#main-search-close').on('click', function (e) {
      e.preventDefault();
      self._$mainSearchHolder.removeClass('active');
      $('body').removeClass('search-active');
      Page.finishLoad('main-search-load');

      if (self._$mainSearchHolder.hasClass('active-on-results')) {
        self._$mainSearchHolderResults.html('');
        self._$mainSearchHolderInput.first().val('');
      }

      let watcher = $(this).closest('.watch-search-results');

      if (watcher.length) {
        watcher.removeClass('search-results-active');
      }
    });

    var mainSearchTimeout = null;
    self._$mainSearchHolderInput.first().on('keyup', function (e) {

      var isUpDown = false;
      var $results = self._$mainSearchHolderResults;
      var selectedIndex = 0;

      if ($results.find('.search-entry').length > 0) {
        selectedIndex = $results.find('.selected').index();
        switch (e.which) {
          case 38: // up
            selectedIndex--;
            isUpDown = true;
            break;

          case 40: // down
            selectedIndex++;
            isUpDown = true;
            break;

          case 13: // enter
            e.preventDefault();
            $results.find('.selected').trigger('click');
            break;
        }
      }

      if (isUpDown) {
        if (selectedIndex < 0) {
          selectedIndex = $results.find('.search-entry').length - 1;
        }

        if (selectedIndex > ($results.find('.search-entry').length - 1)) {
          selectedIndex = 0;
        }


        $results.find('.search-entry.selected').removeClass('selected');
        $results.find('.search-entry:eq(' + selectedIndex + ')').addClass('selected');

        if ($results.find('.search-entry.selected').length > 0) {
          $(this).val($results.find('.search-entry.selected').data('label'));
        }
      }

      //do search
      if (!isUpDown) {
        clearTimeout(mainSearchTimeout);

        mainSearchTimeout = setTimeout(function () {
          self._mainSearch();
        }, 500);

        //navigate through results
      } else {

      }
    });

    $('#search_nav_toggler').on('click', function (e) {
      $('.lang-curr-togglers .select-custom').removeClass('opened');
      $('#main_nav').removeClass('show');
      $('#search_nav').toggleClass('show');
    });

    if (window.location.hash !== '') {
      var hashMatches = window.location.hash.match(/#s=(.+)/);

      if (hashMatches && typeof hashMatches[1] !== 'undefined') {
        self._$mainSearchHolderInput.val(decodeURIComponent(hashMatches[1].replace(/\+/g, ' ')));
        self._$mainSearch.click();
      }
    }
  },

  _mainSearch() {
    const self = this;

    var data = {};
    data['query'] = self._$mainSearchHolderInput.first().val();
    data['action'] = 'main-search';
    Page.finishLoad('main-search-load');
    Page.startLoad('main-search-load', '#main-search-holder input');

    Ajax.post(ajaxurl, data, function (results) {
      self._$mainSearchHolderResults.html(results);
      $('#main-search-holder .results .search-entry').first().addClass('selected');

      if (self._$mainSearchHolder.hasClass('active-on-results')) {
        self._$mainSearchHolder.addClass('active');
      }

      let watcher = $('.watch-search-results');

      if (watcher.length) {
        watcher.addClass('search-results-active');
      }
      Page.finishLoad('main-search-load');

    });
  },
};

module.exports = MainSearch;
